import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environment/environment';

@Injectable({ providedIn: 'root' })
export class MachineService {
  private endpoint = environment.apiEndpoint;

  constructor(private http: HttpClient) { }

  getMachines(
    offset?: number,
    limit?: number,
    filters?: { [key: string]: any }
  ): Observable<any> {
    let url = `${this.endpoint}/v1/machine`;
    const params = new URLSearchParams();

    if (limit !== undefined) params.append('limit', limit.toString());
    if (offset !== undefined) params.append('offset', offset.toString());

    if (filters) {
      Object.keys(filters).forEach(key => {
        if (filters[key] !== null && filters[key] !== undefined) {
          if (Array.isArray(filters[key]) && filters[key].length > 0) {
            const filterObj = filters[key][0];
            if (filterObj?.value !== null && filterObj.value !== undefined && filterObj.value !== '') {
              params.append(key, filterObj.value);
            }
          }
          else if (typeof filters[key] === 'object' && filters[key].value !== null && filters[key].value !== undefined) {
            params.append(key, filters[key].value);
          }
          else if (typeof filters[key] === 'string') {
            params.append(key, filters[key]);
          }
        }
      });
    }

    const queryString = params.toString();
    if (queryString) {
      url += `?${queryString}`;
    }

    return this.http.get(url);
  }

  getMachineDetails(serialNumber: string): Observable<any> {
    const params = new HttpParams().set('serialNumber', serialNumber);
    return this.http.get(`${this.endpoint}/v1/machine/details`, { params });
  }
}
